



















import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DropDownProject extends Vue { 
    @Prop(Array) readonly projectLists: any
    @Prop() public changeState: any
	@Prop() public trackid: any

	projectValue = null as any

	updateState () {
		if (this.projectValue !== null) {
			this.changeState("projectId", this.projectValue.id)
			this.changeState("productType", parseInt(this.projectValue.productId))
		}
		if (this.projectValue === null) {
			this.changeState("projectId", 0)
			this.changeState("productType", 0)
		}
	}
}
